class ResultsUIFacets {
  constructor () {
    this.eventBus = window.theme?.tagalys?.results?.eventBus
    this.container = document.querySelector('[data-tagalys-facets]')
    this.facetsBar = document.querySelector('[data-tagalys-facets-bar]')
    this.facetsSort = document.querySelector('[data-tagalys-facets-sort]')
    this.clearFacetsEl = document.querySelector('[data-tagalys-facets-clear]')
    this.facetsResultsCountEl = document.querySelectorAll('[data-tagalys-facets-results-count]')

    if (!this.eventBus || !this.container) return

    this.showCounts = this.container.hasAttribute('data-show-counts')

    this.eventBus.subscribe('results:state:facets:updated', facets => this.renderFacets(facets))
    this.eventBus.subscribe('results:state:sortOptions:updated', sortOptions => this.renderSort(sortOptions))
    this.eventBus.subscribe('results:state:sortOptions:updated', sortOptions => this.renderSortMobile(sortOptions))

    const existing = window.theme.tagalys.results.stateLayer?.state?.facets
    if (Array.isArray(existing) && existing.length) {
      this.renderFacets(existing)
    }

    const existingSortOptions = window.theme.tagalys.results.stateLayer?.state?.sortOptions
		if (Array.isArray(existingSortOptions) && existingSortOptions.length) {
			this.renderSort(existingSortOptions)
      this.renderSortMobile(existingSortOptions)
		}

		this.setupEventListeners()
  }

  setupEventListeners() {
		this.container.addEventListener('change', this.handleFacetChange.bind(this))
		this.clearFacetsEl.addEventListener('click', this.handleClearFacets.bind(this))
    this.facetsSort.addEventListener('change', this.handleMobileSortChange.bind(this))
	}

  handleFacetChange(event) {
		const target = event.target
		if (target.tagName === 'INPUT' && target.type === 'checkbox') {
			const field = target.dataset.facetField
			const value = target.value

			if (target.checked) {
				this.eventBus.publish('results:ui:facet:added', { field, value })
			} else {
				this.eventBus.publish('results:ui:facet:removed', { field, value })
			}
		}

		if (target.tagName === 'INPUT' && target.type === 'radio') {
			const value = target.value

			window.theme.tagalys.results.SDK.helpers.applySortOption(value)
		}
	}

  handleMobileSortChange(event) {
    event.preventDefault()

    const target = event.target

    if (target.tagName === 'SELECT' && target.name === 'sort_by') {
      const value = target.value

      window.theme.tagalys.results.SDK.helpers.applySortOption(value)
    }
  }

	handleClearFacets(event) {
		const target = event.target

		if (target.closest('[data-tagalys-facets-clear]')) {
			this.eventBus.publish('results:ui:facet:clearAll')
		}
	}

  renderFacets (facets) {
    if (!Array.isArray(facets) || facets.length === 0) {
      this.facetsBar.style.display = 'none'

      return
    }

    this.container.querySelectorAll('[data-tagalys-facet-group]').forEach(el => el.remove())

    const html = facets
      .filter(facet => facet.type === 'checkbox' && Array.isArray(facet.items) && facet.items.length)
      .map((facet, index) => this.renderGroup(facet, index))
      .join('')

    this.container.insertAdjacentHTML('afterbegin', html)
    this.bindAccordion()

    this.facetsResultsCountEl.forEach(el => {
      el.textContent = `${window.theme.tagalys.results.stateLayer.state.pagination.total} Results`
    })
  }

  renderSort (sortOptions) {
		if (!Array.isArray(sortOptions) || window.theme.tagalys.results.stateLayer.state.pagination.total === 0) return

		const sortByContainer = this.container.querySelector('[data-tagalys-sort-by]')
		if (sortByContainer) sortByContainer.remove()

		const html = this.renderSortBy(sortOptions)
		this.container.insertAdjacentHTML('afterbegin', html)
	}

  renderSortMobile (sortOptions) {
		if (!Array.isArray(sortOptions) || window.theme.tagalys.results.stateLayer.state.pagination.total === 0) return

		const sortByContainer = this.facetsSort.querySelector('[data-tagalys-sort-by-mobile]')
		if (sortByContainer) sortByContainer.remove()

		const html = this.renderSortByMobile(sortOptions)
		this.facetsSort.insertAdjacentHTML('afterbegin', html)
	}

  /* ---------- Filter group ---------- */

  renderGroup (facet, index) {
    const label = this.escape(facet.label)
    const options = facet.items.map((item, itemIndex) => this.renderOption(facet, item, itemIndex)).join('')

    return `
      <div data-tagalys-facet-group data-index="${index + 1}">
        <div class="thb-filter js-filter"${index === 0 ? ' open' : ''}>
          <summary class="thb-filter-title"><span></span>${label}</summary>

          <div class="thb-filter-content collapsible__content filter-label--${label}">
            <ul class="${this.listClass(facet)}">
              ${options}
            </ul>
          </div>
        </div>
      </div>
    `
  }

  renderOption (facet, item, itemIndex) {
    const disabled = item.count === 0 && !item.selected
    const label = this.escape(item.label)
    const id = `Filter-${this.escape(facet.label)}-${itemIndex + 1}`
    const count = this.showCounts ? `<span class="count"> (${item.count})</span>` : ''

    return `
      ${this.renderSizeSpacers(facet, itemIndex)}

      <li>
        <input type="checkbox"
          value="${this.escape(item.id)}"
          id="${id}"
          data-facet-field="${this.escape(facet.id)}"
          ${item.selected ? 'checked' : ''}
          ${disabled ? 'disabled' : ''}
        />

        <label for="${id}" class="facet-checkbox${disabled ? ' facet-checkbox--disabled' : ''}" data-tooltip="${label} (${item.count})">
          ${label}${count}
        </label>
      </li>
    `
  }

  /* ---------- Sort By ---------- */

	renderSortBy (sortOptions) {
		const options = sortOptions.map((item, itemIndex) => this.renderSortByOption(item, itemIndex)).join('')

		return `
			<div class="thb-filter-sort-count thb-filter" data-tagalys-sort-by>
				<div class="thb-filter-sort">
					<div class="thb-filter-title">
						${window.theme.tagalys.results.translations?.sortBy || 'Sort By'}
					</div>

					<div class="sort-by">
						${options}
					</div>
				</div>
			</div>
		`
	}

	renderSortByOption (item, itemIndex) {
		const isChecked = item.selected ? 'checked' : ''

		return `
			<div class="sort-by-option">
				<input
					type="radio"
					id="SortByMobile-${itemIndex + 1}"
					name="sort_by"
					value="${this.escape(item.id)}"
					${isChecked}
				>

				<label for="SortByMobile-${itemIndex + 1}" class="sort-by-label">
					<span>${this.escape(item.label)}</span>
				</label>
			</div>
		`
	}

  renderSortByMobile (sortOptions) {
		const options = sortOptions.map((item, itemIndex) => this.renderSortByOptionMobile(item, itemIndex)).join('')

		return `<div class="select" data-tagalys-sort-by-mobile>
        <select
          name="sort_by"
          class="facet-filters__sort select__select resize-select fz-14_140"
          id="SortBy"
          aria-describedby="a11y-refresh-page-message"
        >
          ${options}
        </select>

        <div class="select-arrow">
          <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.75 1.5L3.75 4.5L0.75 1.5" stroke="var(--Color_Black)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
		`
	}

  renderSortByOptionMobile (item, itemIndex) {
		return `<option
        value="${this.escape(item.id)}"
        ${item.selected ? 'selected="selected"' : ''}
      >
        ${this.escape(item.label)}
      </option>
		`
	}

  renderSizeSpacers (facet, itemIndex) {
    if ((facet.label || '').toLowerCase() !== 'size') return ''

    const spacersBeforeItem = { 5: 6, 15: 2 }
    const count = spacersBeforeItem[itemIndex]

    if (!count) return ''

    return '<li><div style="height: 24px;"></div></li>'.repeat(count)
  }

  listClass (facet) {
    let slug = (facet.label || '').toLowerCase()

    if (slug.includes('color') || slug.includes('colour')) slug = ''

    return `list-${this.escape(slug)}`
  }

  /* ---------- Accordion ---------- */

  bindAccordion () {
    this.container.querySelectorAll('[data-tagalys-facet-group] .thb-filter-title').forEach(title => {
      title.addEventListener('click', () => {
        document.querySelectorAll('.thb-filter').forEach(filter => {
          if (filter !== title.parentElement) {
            filter.removeAttribute('open')
          }
        })

        title.parentElement.toggleAttribute('open')
      })
    })
  }

  /* ---------- Helpers ---------- */

  escape (str) {
    if (str == null) return ''

    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }
}

function initResultsUIFacets () {
  window.theme.tagalys.results.facetsUILayer = new ResultsUIFacets()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initResultsUIFacets)
} else {
  initResultsUIFacets()
}
